import Head from 'next/head'
import { GTMtag } from 'lib/tags'
import { GOOGLE_FONTS_STYLESHEET } from 'lib/googleFonts'

interface Props {
  title: string
  description: string
  keyword: string
  image: string
  url: string
  noindexNofollow?: boolean
  favicon?: string
  faviconPng?: string
  faviconSvg?: string
}

const HeadMeta: React.FC<Props> = ({
  title,
  description,
  keyword,
  image,
  url,
  noindexNofollow = false,
  favicon,
  faviconPng,
  faviconSvg,
}) => {
  return (
    <Head>
      <script
        dangerouslySetInnerHTML={{
          __html: `${GTMtag}`,
        }}
      ></script>
      <meta charSet="utf-8" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keyword} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={title} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="google-site-verification" content="M1NrPwIhg3qEUcvmXJoe3Ba8GzyRFeZObOLBQu9agLM" />
      {noindexNofollow && (
        <>
          <meta name="robots" content="noindex,nofollow" />
        </>
      )}
      {faviconPng && faviconSvg ? (
        <>
          <link rel="icon" type="image/png" href={faviconPng} sizes="32x32" />
          <link rel="icon" type="image/svg+xml" href={faviconSvg} />
        </>
      ) : favicon ? (
        <>
          <link rel="icon" href={favicon} />
          <link rel="shortcut icon" href={favicon} />
          <link rel="apple-touch-icon" href={favicon} />
        </>
      ) : (
        <>
          <link rel="icon" type="image/svg+xml" href="/favicon.svg" />
          <link rel="apple-touch-icon" sizes="180x180" href="/favicon.png" />
        </>
      )}
      <link rel="canonical" href={url} />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link href={GOOGLE_FONTS_STYLESHEET} rel="stylesheet" />
    </Head>
  )
}

export default HeadMeta
